// React
import { useEffect, useState } from "react";
// Firebase
import { projectAuth } from "../firebase/config";
// Hook
import { useAuthContext } from "./useAuthContext";
import { signInWithEmailAndPassword } from "firebase/auth";

export const useLogin = (email, password) => {
  // useState variables
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  // useAuthContext variable
  const { dispatch } = useAuthContext();

  const login = async (email, password) => {
    // Updating useState
    setError(null);
    setIsPending(true);

    // Sign In the user
    try {
      const res = await signInWithEmailAndPassword(projectAuth, email, password);

      // dispatch login action
      dispatch({ type: "LOGIN", payload: res.user });

      // Updating useState
      if (!isCancelled) {
        setError(null);
        setIsPending(false);
      }
    } catch (err) {
      // Updating useState
      if (!isCancelled) {
        setError(err.message);
        setIsPending(false);
      }
    }
  };

  // Cleanup function
  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  return { login, error, isPending };
};
